<template>
    <NUIButton
      :obj="this.pipes"
      :displayType="'icon'"
    />
</template>

<script>

import NUIButton from '../../nelsonUI/NUIButton.vue';
import {useModalStore} from '@/store/ModalStore';

export default {
  data () {
    return {
      pipes: {
        label: 'Pipes',
        icon: 'edit',
        value: 'print',
        orientation: 'top',
        marker: 'var(--nelson-green)',
        func: this.handlePipes,
      }
    };
  },
  methods: {
    handlePipes () {
      useModalStore().showModal('pipe');
    }
  },
  components: {
    NUIButton
  }
};
</script>

<style scoped>
.calculations-button {
  width: 100px;
  background-color: yellowgreen;
  cursor: pointer;
}
</style>